const Schema = ({ intl }) => {
  return {
    title: 'App List Upload',
    block: 'applistupload',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title', 'description', 'target_path'],
      },
    ],
    properties: {
      title: {
        title: 'Titel',
        description: 'Titel, der im Block angezeigt wird (optional).',
      },
      description: {
        title: 'Beschreibung',
        description: 'Beschreibung (optional).',
        widget: 'textarea',
      },
      target_path: {
        title: 'Target path (Plone path to store JSON as File)',
        description:
          'Uploads will be stored under the Plone site root in the applist folder by default. Ensure a Folder exists at /applist.',
        default: '/applist',
      },
    },
    required: [],
  };
};

export default Schema;
